import { render, staticRenderFns } from "./home-download2.vue?vue&type=template&id=267e72e0&"
import script from "./home-download2.vue?vue&type=script&lang=js&"
export * from "./home-download2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports